declare var jQuery:any;
import {Ajax} from "./ajax";
declare var product_page_localize:any;
import swal from "sweetalert";

export class MinCartHandler {
    private min_cart_wrapper:any = '.min-cart-item-wrapper';
    private ajax:Ajax;
    private hasQntChanged:boolean = false;

    public constructor() {
        this.ajax = new Ajax( product_page_localize.ajax_url, product_page_localize.nonce );
    }

    public init(){
        this.startCartEvents();
        jQuery(this.min_cart_wrapper).on('create-cart-event', (e:any) => {
            this.startCartEvents();
        });
    }

    public startCartEvents = () =>  {
        jQuery( 'a.remove' ).off( 'click', (e:any) => {this.removeFromCartWUpdate(e) });
        jQuery( 'a.remove' ).on( 'click', (e:any) => {this.removeFromCartWUpdate(e) });

        jQuery( '.shop_table.cart a.remove' ).off( 'click', (e:any) => {this.removeCartTable(e)});
        jQuery( '.shop_table.cart a.remove' ).on( 'click', (e:any) => {this.removeCartTable(e)} );

        jQuery( '.td.product-quantity input' ).off( 'change', (e:any) => {this.updateQuantity(e)});
        jQuery( '.td.product-quantity input' ).on( 'change', (e:any) => {this.updateQuantity(e)});

        jQuery( document ).off( 'updated_wc_div', (e:any) => {this.updatedCart(e)} );
        jQuery( document ).on( 'update_wc_div', (e:any) => {this.updatedCart(e)});
    }

    public removeCartTable = (e:any) => {
        let button:any = jQuery(e.target);
        let remove_url:string = button.attr('href');
        let prodId:string = button.data('product_id');
        let removeCart:any = jQuery.post( remove_url );
        removeCart.done(( data:any ) => {
            let updateCart:any = jQuery.post( product_page_localize.ajax_url, {action: "wc_refresh_min_cart"} );
            updateCart.done(( response:any ) => {
                if (response.success) {
                    jQuery(this.min_cart_wrapper).empty();
                    jQuery(this.min_cart_wrapper).append(response.data.cart);
                    this.startCartEvents();
                }
            });
            jQuery(this.min_cart_wrapper).trigger('update-list', prodId);
        });
    }

    public updateQuantity = (e:any) => {
        this.hasQntChanged = true;
        jQuery( '<input />' ).attr( 'type', 'hidden' )
            .attr( 'name', 'update_cart' )
            .attr( 'value', 'Update Cart' )
            .appendTo( jQuery(".woocommerce-cart-form") );
        jQuery(document).trigger('wc_update_cart');
    }

    public forceUpdatedCart = () => {
        return new Promise((resolve, reject) => {
            this.ajax.callWPAjax('wc_refresh_min_cart',
                (response:any) =>{
                    if (response.success) {
                        jQuery(this.min_cart_wrapper).empty();
                        jQuery(this.min_cart_wrapper).append(response.data.cart);
                        jQuery(this.min_cart_wrapper).trigger('create-cart-event');
                        this.startCartEvents();
                        resolve(true);
                    }
                },
                (err:any) => {
                    console.log('ERROR!!!', err);
                    resolve(false);
                }
            )
        });
    }

    public updatedCart = (e:any) => {
        if (this.hasQntChanged) {
            this.hasQntChanged = false;
            let updateCart:any = jQuery.post( product_page_localize.ajax_url, {action: "wc_refresh_min_cart"} );
            updateCart.done(( response:any ) => {
                if (response.success) {
                    jQuery(this.min_cart_wrapper).empty();
                    jQuery(this.min_cart_wrapper).append(response.data.cart);
                    this.startCartEvents();
                }
            });
        }
    }

    public add_to_cart(e:any) {
        var button:any = e.target;
        return this.add_to_cart_by_product(button, 1);
    }

    public add_to_cart_by_product (button:any, amount:number = 1): Promise<boolean>{
        var get_product_id:any = jQuery(button);
        var product_id:number = get_product_id.data('add-cart');
        var custom_cart_data:any = jQuery(button).attr('custom-cart-data');
        var maxQnty:number = get_product_id.data('max-cart');
        var currQnty:number= get_product_id.data('qnt-cart');

        var $product_qta = amount;

        var postData:any = { action: "addToCart", product_id: product_id, product_qta: $product_qta, nonce: product_page_localize.nonce };
        if(custom_cart_data){
            postData.custom_cart_data = JSON.parse(custom_cart_data);
        }

        get_product_id.addClass('loading');
        let addItem:any = jQuery.post( product_page_localize.ajax_url, postData );
        
        return new Promise((resolve, reject) => {
            addItem.done(( response:any ) => {
                if(response.success){
                    get_product_id.removeClass('loading');
                    currQnty++;
                    if (maxQnty <= currQnty) {
                        // get_product_id.parent().find('.add_cart').hide();
                        // get_product_id.parent().find('.view_cart').show();
                    } else {
                        if (currQnty == 1) {
                            // get_product_id.after('<a href="/cart/" class="added_to_cart wc-forward" title="View cart">View cart</a>')
                        }
                    }

                    this.ajax.callWPAjax('wc_refresh_min_cart',
                        (response:any) =>{
                            if (response.success) {
                                jQuery(this.min_cart_wrapper).empty();
                                jQuery(this.min_cart_wrapper).append(response.data.cart);
                                jQuery(this.min_cart_wrapper).trigger('create-cart-event');
                                this.startCartEvents();
                                resolve(true);
                            }
                        },
                        (err:any) => {
                            console.log('ERROR!!!', err);
                            resolve(false);
                        }
                    );
                } else {
                    this.handleUnsuccessfullAddToCart(response, button);
                    resolve(false);
                }
            });
        });
    }

    handleUnsuccessfullAddToCart = (response: any, button: any) => {
        if (response.notices.error) {

            const { error } = response.notices;

            var errorHandled = false;
            error.map((err: any) => {
                if (err.data.id === "block_two_memberships_in_cart") {
                    errorHandled = true;
                    const data = err.data;
                    swal({
                        title: "Override product in cart?",
                        content: {
                            element: "div",
                            attributes: {
                                innerHTML: `The cart already has the membership "${data.collision.product_name}" in it.`
                            }
                        },
                        icon: "error",
                        buttons: {
                            cancel: { text: "Cancel", visible: true },
                            confirm: { text: "Override", visible: true },
                        },
                    }).then((override: any) => {
                        if (override) {
                            var postData: any = { action: "removeProductByID", product_id: data.collision.product_id, nonce: product_page_localize.nonce };
                            let removeCollisionProduct: any = jQuery.post(product_page_localize.ajax_url, postData);



                            removeCollisionProduct.done((response: any) => {
                                if (response.success) {
                                    // jQuery(`a.add_cart[data-add-cart=${data.collision.product_id}]`).show();
                                    // jQuery(`a.view_cart[data-add-cart=${data.collision.product_id}]`).hide();
                                    this.add_to_cart_by_product(button);
                                } else {
                                    swal({
                                        title: "Erro overriding product in cart!",
                                        text: "Something went wrong. Please try again later.",
                                        icon: "error",
                                    })
                                }
                            });
                        }
                    });
                } else if (err.data.id === "block_already_have_membership") {
                    errorHandled = true;
                    const data = err.data;
                    swal({
                        title: "Users can't have more than one membership!",
                        content: {
                            element: "div",
                            attributes: {
                                innerHTML: `You already have a membership!<br>"${data.existing_membership_product}" is active.`
                            }
                        },
                        icon: "error",
                    });
                }
            });

            if (!errorHandled) {
                swal({
                    title: "Error!",
                    text: response.notices.error[0].notice ?? "Something went wrong. Please try again later.",
                    icon: "error",
                })
            }
        }
    }

    private removeFromCartWUpdate =(e:any) => {
        let button:any = jQuery(e.target);
        let prodId:string = button.data('product_id');
        let cart_item_key:string = button.data('cart_item_key');
        let removeCart:any = jQuery.post( product_page_localize.ajax_url, {action: "removeToCart", cart_item_key:  cart_item_key, nonce: product_page_localize.nonce} );
        removeCart.done(( data:any ) => {
            var done = false;
            if(!done){
                let updateCart:any = jQuery.post( product_page_localize.ajax_url, {action: "wc_refresh_min_cart"} );
                updateCart.done(( response:any ) => {
                    if (response.success) {
                        jQuery(this.min_cart_wrapper).empty();
                        jQuery(this.min_cart_wrapper).append(response.data.cart);
                        this.startCartEvents();
                    }
                    const customCartEvent = new Event('cart_refreshed');
                    window.dispatchEvent(customCartEvent);
                });
                done = true;
            }
            jQuery(this.min_cart_wrapper).trigger('update-list', prodId);
        });
    }
}
